import { slices } from "@/constants/sliceNames";
import { createSlice } from "@reduxjs/toolkit";
import {
  requestApplicationsStatus,
  requestDeleteApplicationStatus,
  requestSingleApplicationStatus,
  requestCreateApplicationStatus,
  requestUpdateApplicationStatus,
} from "../effects/applications-effects";

const initialState = {
  list: [],
  item: null,
  loading: false,
  pageCount: 0,
  error: null,
};

const applicationsSlice = createSlice({
  name: slices.applications,
  initialState,
  extraReducers: {
    ...requestApplicationsStatus,
    ...requestDeleteApplicationStatus,
    ...requestSingleApplicationStatus,
    ...requestCreateApplicationStatus,
    ...requestUpdateApplicationStatus,
  },
});

const { actions, reducer } = applicationsSlice;

export { actions };

export default reducer;
